import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { RollesQuerySorterConfig } from 'fa-kt.types';
import { RollesService } from '../service';

@Component({
  selector: 'fa-kt-rolles-sorter',
  templateUrl: './rolles-sorter.component.html',
  styleUrls: ['./rolles-sorter.component.css'],
})
export class RollesSorterComponent {
  RollesSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public rolles: RollesService,
  ) {
    this.RollesSorterConfig = RollesQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
